//import React, { useState, useEffect } from "react";
//import Loading from "../../component/Loading/Loading";
//import { Link, useParams } from "react-router-dom";
//import { useHistory } from 'react-router-dom';
//import { useSelector } from "react-redux";
//import AlertMsg from '../../component/AlertMsg/AlertMsg';
//import useAxiosInstance from "../../services/useAxiosInstance";
//import BackBtn from "../../utils/BackBtn";
//import { ArrowLeft, Check } from "lucide-react";

//const AssignVendor = () => {
//    const axiosInstance = useAxiosInstance();
//    const history = useHistory();
//    const [vendors, setVendors] = useState([]);
//    const [serviceRequest, setServiceRequest] = useState(null);
//    const [serviceTypeName, setServiceTypeName] = useState("");
//    const [loading, setLoading] = useState(false);
//    const [communityData, setCommunityData] = useState(null);
//    const [selectedVendors, setSelectedVendors] = useState([]);
//    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
//    const communityId = useSelector((state) => state.auth.communityId);
//    const { serviceRequestId } = useParams();

//    useEffect(() => {
//        axiosInstance
//            .get(`/api/public/servicerequest/getByServiceRequestId/${serviceRequestId}`)
//            .then((response) => {
//                setServiceRequest(response.data);
//                fetchServiceTypeName(response.data.serviceTypeId);
//            })
//            .catch((error) => {
//                console.error("Error fetching service request:", error);
//            });

//        axiosInstance
//            .get(`/api/public/community/getCommunity/${communityId}`)
//            .then((response) => {
//                setCommunityData(response.data);
//            })
//            .catch((error) => {
//                console.error("Error fetching community data:", error);
//            });
//    }, [serviceRequestId, communityId]);

//    useEffect(() => {
//        if (serviceRequest && communityData) {
//            axiosInstance
//                .get(`/api/public/vendor/byZipCodeAndServiceType`, {
//                    params: {
//                        serviceTypeId: serviceRequest.serviceTypeId,
//                        zipCode: communityData.zipCode,
//                    },
//                })
//                .then((response) => {
//                    setVendors(response.data);
//                })
//                .catch((error) => {
//                    console.error("Error fetching vendors:", error);
//                });
//        }
//    }, [serviceRequest, communityData]);

//    const fetchServiceTypeName = (serviceTypeId) => {
//        axiosInstance
//            .get(`/api/public/servicetype/getOne/${serviceTypeId}`)
//            .then((response) => {
//                if (response.data && response.data.name) {
//                    setServiceTypeName(response.data.name);
//                }
//            })
//            .catch((error) => {
//                console.error("Error fetching service type name:", error);
//            });
//    };

//    const handleVendorSelect = (vendorId) => {
//        setSelectedVendors((prevSelected) =>
//            prevSelected.includes(vendorId)
//                ? prevSelected.filter((id) => id !== vendorId)
//                : [...prevSelected, vendorId]
//        );
//    };

//    const handleVendorAssign = async () => {
//        setLoading(true);
//        try {
//            const response = await axiosInstance.post(
//                `/api/public/assignedVendors/addAssignedVendors`,
//                {
//                    communityId: communityId,
//                    serviceRequestId: serviceRequestId,
//                    vendorIdList: selectedVendors,
//                }
//            );

//            if (response.status === 200) {
//                setSelectedVendors([]);

//                try {
//                    const statusResponse = await axiosInstance.patch(
//                        `/api/public/servicerequest/updateServiceRequestStatus/${serviceRequestId}`,
//                        null,
//                        {
//                            params: {
//                                serviceRequestId: serviceRequestId,
//                                serviceRequestStatusId: 58119,
//                            },
//                        }
//                    );

//                    if (statusResponse.status === 200) {
//                        setAlert({ visible: true, message: 'Vendor assigned successfully!', type: 'success' });
//                        setTimeout(() => {
//                            history.goBack();
//                        }, 2500);
//                    } else {
//                        console.error("Error updating service request status:", statusResponse);
//                    }
//                } catch (error) {
//                    console.error("Error updating service request status:", error);
//                    setAlert({ visible: true, message: 'Error Vendor assigned: Please try again later', type: 'error' });
//                }
//            }
//        } catch (error) {
//            console.error("Error assigning vendor:", error);
//        } finally {
//            setLoading(false);
//        }
//    };

//    if (!serviceRequest || !communityData) {
//        return <Loading />;
//    }

//    return (
//        <div className="bg-gray-50 min-h-screen p-4">
//            {loading && <Loading />}
//            {!loading && (
//                <div className="max-w-7xl mx-auto">
//                    {alert.visible && (
//                        <AlertMsg
//                            message={alert.message}
//                            type={alert.type}
//                            onClose={() => setAlert({ ...alert, visible: false })}
//                        />
//                    )}
//                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//                        <div className="flex justify-between items-center p-4 border-b border-gray-200">
//                            <div className="flex items-center">
//                                <button
//                                    onClick={() => history.goBack()}
//                                    className="inline-flex items-center mr-4 text-blue-500 hover:text-blue-700"
//                                >
//                                    <ArrowLeft size={18} />
//                                </button>
//                                <h1 className="text-2xl font-bold text-gray-800">Vendors Assign</h1>
//                            </div>
//                        </div>

//                        <div className="p-4">
//                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                                <div>
//                                    <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Access Code</label>
//                                    <input
//                                        type="text"
//                                        value={serviceRequest.vendorAccessCode}
//                                        readOnly
//                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                                    />
//                                </div>
//                                <div>
//                                    <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
//                                    <input
//                                        type="text"
//                                        value={serviceRequest.description}
//                                        readOnly
//                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                                    />
//                                </div>
//                                <div>
//                                    <label className="block text-sm font-medium text-gray-700 mb-1">Service Type Name</label>
//                                    <input
//                                        type="text"
//                                        value={serviceTypeName}
//                                        readOnly
//                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                                    />
//                                </div>
//                                <div>
//                                    <label className="block text-sm font-medium text-gray-700 mb-1">Document</label>
//                                    <div className="mt-2">
//                                        {serviceRequest.docUrl ? (
//                                            <a href={serviceRequest.docUrl} target="_blank" rel="noopener noreferrer">
//                                                <img
//                                                    src={serviceRequest.docUrl}
//                                                    alt="document"
//                                                    className="w-20 h-20 object-cover border border-gray-300 rounded-md"
//                                                />
//                                            </a>
//                                        ) : (
//                                            <p className="text-gray-500">No Image</p>
//                                        )}
//                                    </div>
//                                </div>
//                            </div>

//                            <div className="overflow-x-auto">
//                                <table className="min-w-full divide-y divide-gray-200">
//                                    <thead className="bg-blue-400">
//                                        <tr>
//                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Select</th>
//                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Vendor Name</th>
//                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Business Phone</th>
//                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Email</th>
//                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Active Status</th>
//                                        </tr>
//                                    </thead>
//                                    <tbody className="bg-white divide-y divide-gray-200">
//                                        {vendors.length === 0 ? (
//                                            <tr>
//                                                <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                                            </tr>
//                                        ) : (
//                                            vendors.map((vendor) => (
//                                                <tr key={vendor.vendorId} className="hover:bg-gray-50">
//                                                    <td className="px-6 py-4 whitespace-nowrap text-center">
//                                                        <input
//                                                            type="checkbox"
//                                                            checked={selectedVendors.includes(vendor.vendorId)}
//                                                            onChange={() => handleVendorSelect(vendor.vendorId)}
//                                                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
//                                                        />
//                                                    </td>
//                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.name}</td>
//                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{vendor.businessPhone}</td>
//                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{vendor.emailId}</td>
//                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
//                                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${vendor.activeStatus ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
//                                                            }`}>
//                                                            {vendor.activeStatus ? "Active" : "Inactive"}
//                                                        </span>
//                                                    </td>
//                                                </tr>
//                                            ))
//                                        )}
//                                    </tbody>
//                                </table>
//                            </div>

//                            {vendors.length > 0 && (
//                                <div className="flex justify-end mt-6 space-x-3">
//                                    <Link
//                                        to="/service-request"
//                                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//                                    >
//                                        Cancel
//                                    </Link>
//                                    <button
//                                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 flex items-center gap-2"
//                                        onClick={handleVendorAssign}
//                                        disabled={selectedVendors.length === 0}
//                                    >
//                                        <Check size={18} />
//                                        <span>Submit</span>
//                                    </button>
//                                </div>
//                            )}
//                        </div>
//                    </div>
//                </div>
//            )}
//        </div>
//    );
//};

//export default AssignVendor;

import React, { useState, useEffect } from "react";
import Loading from "../../component/Loading/Loading";
import { Link, useParams } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import useAxiosInstance from "../../services/useAxiosInstance";
import BackBtn from "../../utils/BackBtn";
import { ArrowLeft, Check, FileText, File, Image as ImageIcon } from "lucide-react";
import { FaFilePdf } from "react-icons/fa";

const AssignVendor = () => {
    const axiosInstance = useAxiosInstance();
    const history = useHistory();
    const [vendors, setVendors] = useState([]);
    const [serviceRequest, setServiceRequest] = useState(null);
    const [serviceTypeName, setServiceTypeName] = useState("");
    const [loading, setLoading] = useState(false);
    const [communityData, setCommunityData] = useState(null);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
    const communityId = useSelector((state) => state.auth.communityId);
    const { serviceRequestId } = useParams();

    // Helper function to detect file type and get appropriate display
    const getFileDisplay = (fileUrl) => {
        if (!fileUrl) return null;

        // Extract filename from URL
        const urlParts = fileUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
        const fileExtension = fileName.split('.').pop()?.toLowerCase();

        // Define image extensions
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];

        const isImage = imageExtensions.includes(fileExtension);

        if (isImage) {
            return {
                type: 'image',
                element: (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="block">
                        <img
                            src={fileUrl}
                            alt="Document thumbnail"
                            className="w-20 h-20 object-cover border border-gray-300 rounded-md cursor-pointer hover:opacity-80 transition-opacity"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                            }}
                        />
                        <div className="hidden w-20 h-20 border border-gray-300 rounded-md flex items-center justify-center bg-gray-100">
                            <ImageIcon size={24} className="text-gray-500" />
                            <span className="text-xs text-gray-500 ml-1">IMG</span>
                        </div>
                    </a>
                )
            };
        } else {
            // For non-image files, show appropriate icon and filename
            let icon;
            let label;

            switch (fileExtension) {
                case 'pdf':
                    icon = <FaFilePdf size={24} className="text-red-500" />;
                    label = 'PDF';
                    break;
                case 'doc':
                case 'docx':
                    icon = <FileText size={24} className="text-blue-500" />;
                    label = 'DOC';
                    break;
                case 'txt':
                    icon = <FileText size={24} className="text-gray-500" />;
                    label = 'TXT';
                    break;
                default:
                    icon = <File size={24} className="text-gray-500" />;
                    label = fileExtension?.toUpperCase() || 'FILE';
            }

            return {
                type: 'document',
                element: (
                    <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-20 h-20 border border-gray-300 rounded-md flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
                    >
                        {icon}
                        <span className="text-xs text-gray-600 mt-1 text-center leading-tight">
                            {label}
                        </span>
                    </a>
                )
            };
        }
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/public/servicerequest/getByServiceRequestId/${serviceRequestId}`)
            .then((response) => {
                setServiceRequest(response.data);
                fetchServiceTypeName(response.data.serviceTypeId);
            })
            .catch((error) => {
                console.error("Error fetching service request:", error);
            });

        axiosInstance
            .get(`/api/public/community/getCommunity/${communityId}`)
            .then((response) => {
                setCommunityData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching community data:", error);
            });
    }, [serviceRequestId, communityId]);

    useEffect(() => {
        if (serviceRequest && communityData) {
            axiosInstance
                .get(`/api/public/vendor/byZipCodeAndServiceType`, {
                    params: {
                        serviceTypeId: serviceRequest.serviceTypeId,
                        zipCode: communityData.zipCode,
                    },
                })
                .then((response) => {
                    setVendors(response.data);
                })
                .catch((error) => {
                    console.error("Error fetching vendors:", error);
                });
        }
    }, [serviceRequest, communityData]);

    const fetchServiceTypeName = (serviceTypeId) => {
        axiosInstance
            .get(`/api/public/servicetype/getOne/${serviceTypeId}`)
            .then((response) => {
                if (response.data && response.data.name) {
                    setServiceTypeName(response.data.name);
                }
            })
            .catch((error) => {
                console.error("Error fetching service type name:", error);
            });
    };

    const handleVendorSelect = (vendorId) => {
        setSelectedVendors((prevSelected) =>
            prevSelected.includes(vendorId)
                ? prevSelected.filter((id) => id !== vendorId)
                : [...prevSelected, vendorId]
        );
    };

    const handleVendorAssign = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post(
                `/api/public/assignedVendors/addAssignedVendors`,
                {
                    communityId: communityId,
                    serviceRequestId: serviceRequestId,
                    vendorIdList: selectedVendors,
                }
            );

            if (response.status === 200) {
                setSelectedVendors([]);

                try {
                    const statusResponse = await axiosInstance.patch(
                        `/api/public/servicerequest/updateServiceRequestStatus/${serviceRequestId}`,
                        null,
                        {
                            params: {
                                serviceRequestId: serviceRequestId,
                                serviceRequestStatusId: 58119,
                            },
                        }
                    );

                    if (statusResponse.status === 200) {
                        setAlert({ visible: true, message: 'Vendor assigned successfully!', type: 'success' });
                        setTimeout(() => {
                            history.goBack();
                        }, 2500);
                    } else {
                        console.error("Error updating service request status:", statusResponse);
                    }
                } catch (error) {
                    console.error("Error updating service request status:", error);
                    setAlert({ visible: true, message: 'Error Vendor assigned: Please try again later', type: 'error' });
                }
            }
        } catch (error) {
            console.error("Error assigning vendor:", error);
        } finally {
            setLoading(false);
        }
    };

    if (!serviceRequest || !communityData) {
        return <Loading />;
    }

    return (
        <div className="bg-gray-50 min-h-screen p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="flex justify-between items-center p-4 border-b border-gray-200">
                            <div className="flex items-center">
                                <button
                                    onClick={() => history.goBack()}
                                    className="inline-flex items-center mr-4 text-blue-500 hover:text-blue-700"
                                >
                                    <ArrowLeft size={18} />
                                </button>
                                <h1 className="text-2xl font-bold text-gray-800">Vendors Assign</h1>
                            </div>
                        </div>

                        <div className="p-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Access Code</label>
                                    <input
                                        type="text"
                                        value={serviceRequest.vendorAccessCode}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                                    <input
                                        type="text"
                                        value={serviceRequest.description}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Service Type Name</label>
                                    <input
                                        type="text"
                                        value={serviceTypeName}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Document</label>
                                    <div className="mt-2">
                                        {serviceRequest.docUrl ? (
                                            getFileDisplay(serviceRequest.docUrl)?.element
                                        ) : (
                                            <div className="w-20 h-20 border border-gray-300 rounded-md flex items-center justify-center bg-gray-100">
                                                <File size={24} className="text-gray-400" />
                                                <span className="text-xs text-gray-500 ml-1">No File</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-blue-400">
                                        <tr>
                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Select</th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Vendor Name</th>
                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Business Phone</th>
                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Email</th>
                                            <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Active Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {vendors.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                            </tr>
                                        ) : (
                                            vendors.map((vendor) => (
                                                <tr key={vendor.vendorId} className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedVendors.includes(vendor.vendorId)}
                                                            onChange={() => handleVendorSelect(vendor.vendorId)}
                                                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                                        />
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{vendor.businessPhone}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{vendor.emailId}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${vendor.activeStatus ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                                                            }`}>
                                                            {vendor.activeStatus ? "Active" : "Inactive"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {vendors.length > 0 && (
                                <div className="flex justify-end mt-6 space-x-3">
                                    <Link
                                        to="/service-request"
                                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                                    >
                                        Cancel
                                    </Link>
                                    <button
                                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 flex items-center gap-2"
                                        onClick={handleVendorAssign}
                                        disabled={selectedVendors.length === 0}
                                    >
                                        <Check size={18} />
                                        <span>Submit</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AssignVendor;